import React from "react";

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

/** A column, and a plus on the side the new one lands. */
export const AddColumnRightIcon = (props: IconProps): React.JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path fillRule="evenodd" d="M3 3h8v18H3zm2 2v14h4V5z" />
    <path d="M16.5 8h2v3h3v2h-3v3h-2v-3h-3v-2h3z" />
  </svg>
);

export const AddColumnLeftIcon = ({
  style,
  ...props
}: IconProps): React.JSX.Element => (
  <AddColumnRightIcon
    {...props}
    style={{ ...style, transform: "scaleX(-1)" }}
  />
);
